export default "__VITE_ASSET__DCi6SeS$__"